import React from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from '../theme/theme';
import '../components/ErrorReporting';
import { useFrontendConfiguration } from '../components/FrontendConfigurationProvider';
import { ErrorReportingWrapper } from '../components/ErrorReporting';
import globalTranslationManager from '../../translation/frontend/components/translation_manager';

import VoicePluginWidget from '@/web_voice/frontend/VoicePluginWidget';

export default function VoicePluginApp({ token, fullscreen }) {
  const config = useFrontendConfiguration();
  if (fullscreen) {
    document.title =
      config.frontend.environment_title || config.frontend.top_bar_title;
  }
  globalTranslationManager.enabled =
    config.frontend.enable_automatic_frontend_translation;

  return (
    <ErrorReportingWrapper>
      <ThemeProvider theme={theme}>
        <VoicePluginWidget token={token} fullscreen={fullscreen} />
      </ThemeProvider>
    </ErrorReportingWrapper>
  );
}
